// Copyright 2025 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from "react";

export const Cut = ({ size, stroke }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      stroke={stroke}
      strokeWidth="2px"
    >
      <ellipse cx="9.74" cy="13.66" rx="5.74" ry="5.54" />
      <ellipse cx="9.74" cy="34.34" rx="5.74" ry="5.54" />
      <line x1="14.64" y1="16.89" x2="44" y2="37.28" />
      <line x1="29.79" y1="20.56" x2="44" y2="10.87" />
      <line x1="14.64" y1="30.9" x2="24.8" y2="23.96" />
    </svg>
  );
};
